module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido@2x-9374ec8e0e59c367f9cfe307af921b01.webp";